<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                title="业务员信息"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏  end-->
        <!--内容 start-->
        <div style="margin-top: 1.5rem">
            <van-cell title="基本信息" is-link @click="basic_information"/>
            <!--<van-cell title="商户信息" is-link @click="store_information"/>-->
            <!-- <van-cell title="员工管理" is-link @click="staff_management"/>
            <van-cell title="我的客服" is-link @click="service_information"/> -->
            <van-cell title="修改密码" is-link @click="change_password" value="修改"/>
            <van-cell title="微信解绑" is-link @click="wxUnbind"/>
            <van-cell title="退出登录" is-link @click="sign_out"/>
        </div>
        <!--内容 end-->
    </div>
</template>

<script>
    import {Dialog,Toast,Notify} from 'vant';

    export default {
        name: "SalesmanInformation",
        methods: {
            // 左侧返回
            onClickLeft() {
                this.$router.push("/SalesmanHome");
            },
            // 基本信息
            basic_information() {
                // 跳转至基本信息
                this.$router.push("/SalesmanBaseInfo");
            },
            // // 门店信息
            // store_information() {
            //     // 跳转至门店信息
            //     this.$router.push("/MerchantInformation");
            // },
            // 员工管理
            // staff_management() {
            //     // 跳转至员工管理
            //     this.$router.push("/StaffManagement");
            // },
            // 客服信息
            // service_information() {
            //     // 跳转至客服信息
            //     this.$router.push("/ServiceInformation");
            // },
            // 修改密码
            change_password(){
                this.$router.push("/SalesmanChangePwd")
            },
            // 微信解绑
            wxUnbind() {
                Dialog.confirm({
                    title: '温馨提示',
                    message: '您确定要解除绑定吗？',
                }).then(() => {
                    this.$http.get('/wechat/api.salesman/wxUnbind', {
                    }).then(response => {
                        if (response && response.data.code == 200) {
                            Notify({type: 'success', message: response.data.msg});
                            this.$router.push("/SalesmanLogin");
                            // window.history.go(-1);//返回上一页
                        } else {
                            Notify({type: 'danger', message: response.data.msg});
                             window.history.go(-2);
                        }
                    });
                })
                    .catch(() => {
                        // on cancel
                    });
            },
            // 退出登录
            sign_out() {
                Dialog.confirm({
                    title: '温馨提示',
                    message: '您确定要退出吗？',
                }).then(() => {
                    this.Logout()
                })
                    .catch(() => {
                        // on cancel
                    });
            },

            // 退出登录请求
            Logout(){
                var toast = Toast.loading({
                    duration: 0,
                    message: '正在退出',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                // this.$http.get('/wechat/user/merchant_logout', {
                //     params: {
                //         merchant_id:window.sessionStorage.getItem("commercialId"),
                //         salesman_id:window.localStorage.getItem('salesman_id'),
                //     }
                // }).then(response => {
                    // 跳转至登陆界面
                    toast.clear();
                    window.localStorage.setItem("salesman_token",'')
                    // sessionStorage.clear();
					// localStorage.clear();
                    // console.log("退出成功"+response.data);
                    this.$router.push("/SalesmanLogin");

                // })
            },
        },
    }
</script>

<style scoped>
    /*标题整体*/
    .topbar {
        background: #00aaee;
        color: #fff;
        padding: 13px 0;
        width: 100%;
        text-align: center;
    }
</style>